// PHI/PII protection: redacta RUTs chilenos en cualquier string antes de renderizar.
// Patrón aceptado: 7-8 dígitos + dash + dígito verificador o 'k'/'K'.
// Wipxap es healthcare adyacente — issue titles pueden contener RUTs de pacientes reales.
const RUT_PATTERN = /\b\d{7,8}-[\dkK]\b/g

export function redactRut(input: string): string {
  return input.replace(RUT_PATTERN, '<RUT-REDACTADO>')
}
